import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { ElevatedButton } from '@producer/ui-kit';

import { DeleteProjectModal } from '../modals/delete-project.modal';
import { Project } from '../../../app/entities';
import { tabPool } from '../../tabs/models/tabs-pool';

import styles from './danger-zone.module.scss';

type DangerZoneProps = {
  project?: Project;
};

export const DangerZone: React.FC<DangerZoneProps> = observer(({ project }) => {
  const { spaceId } = useParams() as { spaceId: string };

  const navigate = useNavigate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

  const handleOnDeleteClick = () => {
    setIsDeleteModalOpen(true);
  };

  const handleSuccess = () => {
    if (!project) {
      return;
    }
    const href = `/space/${spaceId}`;

    const tab = tabPool.elements.find((tab) => tab.key === project?._id);
    if (tab) {
      tab.close();
    }
    navigate(href);
  };

  return (
    <div className={styles.container}>
      <Header>Danger Zone</Header>

      <div className={styles.content}>
        <SettingsCard>
          <Content>
            <TitleWrapper>
              <h3>Transfer ownership</h3>
              <ComingSoon>Coming soon</ComingSoon>
            </TitleWrapper>

            <p>Transfer this project to another space.</p>
          </Content>

          <ElevatedButton variant="default" text="Transfer" disabled />
        </SettingsCard>

        <SettingsCard>
          <Content>
            <TitleWrapper>
              <h3>Archive this project</h3>
              <ComingSoon>Coming soon</ComingSoon>
            </TitleWrapper>

            <p>Mark this project as archived and read-only.</p>
          </Content>

          <ElevatedButton variant="default" text="Archive this project" disabled />
        </SettingsCard>

        <SettingsCard>
          <Content>
            <h3>Delete this project</h3>
            <p>Once you delete a project, there is no coming back. Please be certain.</p>
          </Content>

          <ElevatedButton
            variant="danger"
            onClick={handleOnDeleteClick}
            text="Delete this project"
          />
        </SettingsCard>
      </div>

      {project && isDeleteModalOpen && (
        <DeleteProjectModal
          onCancel={() => setIsDeleteModalOpen(false)}
          onSuccess={handleSuccess}
          projectId={project?._id}
        />
      )}
    </div>
  );
});

const SettingsCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 0;

  &:first-child {
    padding-top: 0;
  }

  &:not(:last-child) {
    border-bottom: 0.1rem solid var(--color-grey-7-5);
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

const Header = styled.h2`
  font-size: 1.6rem;
  padding-bottom: 1.6rem;
  border-bottom: 0.1rem solid var(--color-grey-7-5);
`;

export const ComingSoon = styled.div`
  border-radius: var(--border-radius-medium);
  background: var(--color-grey-8);
  color: #f7f8f877;
  font-size: 1rem;
  text-transform: uppercase;
  padding: 0.4rem 0.8rem;
`;
